import { useInstance } from '@meraki-internal/react-dependency-injection';
import { ICareMapNoteTarget } from '../model/ICareMapNoteTarget';
import { useSubscription } from '@meraki-internal/state';
import { CareMapDrawerPage } from '../../components/CareMapDrawerPage';
import { HistoryViewModel } from '../../support/HistoryViewModel';
import { CareMapDrawerState } from '../../caremap/CareMapDrawerState';
import { ActiveCaremapNoteCreator } from './ActiveCaremapNoteCreator';
import { IonButton } from '@ionic/react';
import { useNoteCreator } from './useNoteCreator';

export const AddNoteUsingCareMapDrawer: React.FC<{ noteTarget: ICareMapNoteTarget; }> = ({ noteTarget }) => {
    const drawerState = useInstance(CareMapDrawerState);
    useSubscription(() => drawerState);

    const history = useInstance(HistoryViewModel);

    const onDidEnter = () => {
        drawerState.setIsMaskingFocusedCareMap(true);
    };

    const onWillLeave = () => {
        drawerState.setIsMaskingFocusedCareMap(false);
    };

    const { noteVM, saveAndClose } = useNoteCreator({
        noteTarget,
        onSaved: () => history.back()
    });

    return (
        <CareMapDrawerPage
            title="Add Note"
            stretchHeight
            hasBack={false}
            hasClose={false}
            enteredHandler={onDidEnter}
            leavingHandler={onWillLeave}
            data-type="note-editor"
            buttons={(
                <>
                    <IonButton
                        data-type="save-button"
                        disabled={!noteVM.canSave()}
                        onClick={saveAndClose}>Save</IonButton>
                    <IonButton data-type="cancel-button" fill="outline" onClick={() => {
                        history.back();
                    }}>Cancel</IonButton>
                </>
            )}
        >
            <ActiveCaremapNoteCreator noteVM={noteVM} includeTemplates />
        </CareMapDrawerPage>
    );
};
